import React, { useState, useEffect } from "react"
import { NewsFilterSelect } from "./style"
import { useDidMountEffect } from "utils/helpers/useDidMountEffect"
import "url-search-params-polyfill"

const NewsFilter = ({ categories, setFilter, setCurrentPage, staff }) => {
  let options = categories?.slice(0, categories.length).map(cat => {
    return {
      value: cat.slug || cat?.name?.replace("&amp;", "&"),
      label: cat?.name?.replace("&amp;", "&"),
    }
  })

  options = [
    { value: "all", label: `${staff ? " All staff" : " All topics"}` },
    ...options,
  ]

  const [value, setValue] = useState(options[0])

  useEffect(() => {
    if (typeof window !== `undefined`) {
      const urlParams = new URLSearchParams(window.location.search)
      const filtersParam = urlParams?.get("f")

      if (filtersParam) {
        const chosenFilter = options.find(cat => cat.value === filtersParam)

        chosenFilter &&
          setValue({ value: chosenFilter.value, label: chosenFilter.label })
      }
    }
  }, [])

  useDidMountEffect(() => {
    setFilter(value)
  }, [value])

  const handleSelect = e => {
    setValue(e)

    setCurrentPage(1)
  }

  return (
    <NewsFilterSelect options={options} value={value} onChange={handleSelect} />
  )
}

export default NewsFilter
